<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="budget-plan-with-draw-detail"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="plan-with-draw-detail"
    @shortkeyAction="shortkeyAction"
    class="ba-with-draw-detail"
  >
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide step-1"
        leftIcon="ic-guide"
        @click="guide"
        tooltipIconLeft="Hướng dẫn chức năng"
      />

      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".ba-with-draw-detail"></ms-tour>
      <ms-button
        text="Phím tắt"
        tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide step-2"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />

      <div
        class="button icon24 setting-small mr-2"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'"></div>
      <a target="_blank" :href="linkHelp($ms.constant.Help.BAWithDraw)">
        <div class="button icon24 ic-question mr-2" v-tooltip="'Trợ giúp'" shortkey-target="Help"></div>
      </a>
    </template>
    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="amount-text">Tổng tiền</div>
        <div class="central-title">
          <div class="title-control-group" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>

        <!-- Bên trên  -->
        <div class="above-container flex-row" v-show="toggleAbove">
          <div class="above-left flex">
            <div class="flex-row control-group">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Tài khoản số">Tài khoản chi</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  mapField="bank_account"
                  v-model="model.bank_account"
                  v-model:display="model.bank_account"
                  :disabled="viewing"
                  :initText="model.bank_account"
                  :data="bankInfoCombo"
                  :dropdownWidth="600"
                  :columns="bankColumns"
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                  quickAdd="BankInfoDetail"
                  quickSearch="BankInfoQuickSearch"
                  :quickSearchParam="quickSearchParam.BankInfo"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  v-model="model.bank_name"
                  :maxLength="255"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  mapField="bank_account"
                  v-model="model.bank_account"
                  v-model:display="model.bank_account"
                  :disabled="viewing"
                  :initText="model.bank_account"
                  :data="comboboxDataRemote.bank"
                  :dropdownWidth="600"
                  :columns="bankColumns"
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                  quickAdd="BankInfoDetail"
                  :queryMode="'remote'"
                  quickSearch="BankInfoQuickSearch"
                  :quickSearchParam="quickSearchParam.BankInfo"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onBankInfoComboboxLoadData(payload, null, {
                        dataField: 'bank',
                      })
                  "
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  v-model="model.bank_name"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Nội dung thanh toán">Nội dung TT</label>
              </div>
              <div class="control-right">
                <ms-input
                  class=""
                  v-model="model.journal_memo"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <!-- <div class="title-control-group">Đơn vị nhận tiền</div> -->

            <div class="flex-row control-group">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Đơn vị nhận">Đơn vị nhận</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObjectBAWithDraw({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :dropdownWidth="600"
                  :data="accountingObjectCombo"
                  :columns="accountingObjectCustomColumns"
                  :quickAddMulti="quickAddMultiItems"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                  :disabled="viewing && !isQuickEditVoucher"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObjectBAWithDraw({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.accountingObject"
                  :columns="accountingObjectCustomColumns"
                  :quickAddMulti="quickAddMultiItems"
                  :queryMode="'remote'"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'accountingObject',
                      })
                  "
                  :rules="[
                    {name: $ms.constant.ValidateRule.ForceSelection},
                    {name: $ms.constant.ValidateRule.RiskCustomerVendor},
                  ]"
                  :isValidateRiskCustomerVendor="true"
                  @blur="
                    async (event, me) =>
                      await validateRiskCustomerVendor($ms.constant.ValidateRule.RiskCustomerVendor, me)
                  "
                >
                  <template v-slot:error-extend>
                    <span @mouseleave="isShowRiskPopup = false">
                      <span
                        v-if="isShowQuestionIcon && riskWarningMessage"
                        class="icon24 ic-information-red ml-1"
                        @mouseover="isShowRiskPopup = true"
                      ></span>
                      <alert-risk-customer-vendor-popup
                        v-if="isShowRiskPopup && riskWarningMessage"
                        :riskWarningMessage="riskWarningMessage"
                        :taxCode="model.company_tax_code"
                        :referenceDocument="riskWarningMessage.document_name"
                        :riskType="riskWarningMessage.riskType"
                        :closedDate="riskWarningMessage.closedDate"
                        :modifiedDate="riskWarningMessage.modifiedDate"
                      />
                    </span>
                  </template>
                </ms-combobox>
                <ms-input
                  class="flex3"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                  :disabled="viewing && !isQuickEditVoucher"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Địa chỉ">Địa chỉ</label>
              </div>
              <div class="control-right">
                <ms-input
                  class=""
                  v-model="model.accounting_object_address"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Tài khoản">Tài khoản nhận</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  :checkExits="false"
                  v-model="model.accounting_object_bank_account"
                  v-model:display="model.accounting_object_bank_account"
                  :disabled="viewing && !isQuickEditVoucher"
                  :initText="model.accounting_object_bank_account"
                  :data="bankInfoCombo"
                  :dropdownWidth="600"
                  :columns="bankInfoColumns"
                  @selected="accountingObjectBankSelected"
                  :forceSelection="false"
                  :rules="[]"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  v-model="model.accounting_object_bank_name"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  :checkExits="false"
                  v-model="model.accounting_object_bank_account"
                  v-model:display="model.accounting_object_bank_account"
                  :disabled="viewing && !isQuickEditVoucher"
                  :initText="model.accounting_object_bank_account"
                  :data="comboboxDataRemote.bankAccount"
                  :dropdownWidth="600"
                  :columns="bankInfoColumns"
                  @selected="accountingObjectBankSelected"
                  :remoteFilter="true"
                  :forceSelection="false"
                  :rules="[]"
                  :maxLength="50"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  v-model="model.accounting_object_bank_name"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group" v-if="isShowVoucherReference">
              <div class="control-title mr-2" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Tham chiếu">Tham chiếu</label>
              </div>
              <div class="control-right align-item-center voucher-reference">
                <div class="voucher-reference-item" v-if="voucherReferenceItems[0]?.ref_no">
                  <div class="ref-no d-flex">
                    <a class="text-link" @click="showTargetLink(voucherReferenceItems[0])">{{
                      voucherReferenceItems[0]?.ref_no
                    }}</a>
                    <label class="icon24 ic-remove" v-if="!viewing" @click="removeVoucherReference"></label>
                  </div>
                </div>

                <label class="text-link more-voucher-reference icon24" @click="showFormVoucherReference"></label>
              </div>
            </div>
          </div>
          <div class="above-right">
            <div class="seperator-line"></div>
            <div class="flex-row control-group mt-1">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày chứng từ">Ngày CT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.ref_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: 'required'}]"
                  @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày hạch toán">Ngày HT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: 'required'}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số chứng từ">Số CT</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  v-model="model.ref_no"
                  :disabled="viewing"
                  :rules="[{name: 'required'}]"
                  :maxLength="20"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số cam kết chi">Số CKC</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing"
                  v-model="model.bu_commitment_request_ref_no"
                  rightIcon="option-tab"
                  :isClickRightIcon="true"
                  @clickRightIcon="onClickCKC(this)"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Bên dưới -->
        <div class="under-container flex1">
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></button>
          <button
            class="toggle-above icon24"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></button>
          <ms-resize-screen isFlex class="flex-column flex">
            <template v-slot:content-master>
              <div class="toolbar-grid flex-between">
                <div class="content-left">
                  <div class="item-tabs" :class="{active: selectedTab == 1}" @click="selectedTabHandler(1)">
                    Hạch toán
                  </div>
                  <div class="item-tabs" :class="{active: selectedTab == 2}" @click="selectedTabHandler(2)">
                    Thống kê
                  </div>
                  <div
                    class="item-tabs"
                    :class="{active: selectedTab == 3}"
                    @click="selectedTabHandler(3)"
                    v-if="useTA"
                  >
                    Thuế
                  </div>
                </div>
                <div class="flex-row flex-center">
                  <label class="ml-2 text-nowrap bold">Loại tiền</label>

                  <div class="ml-1 w80px">
                    <ms-combobox
                      :columns="currencyColumns"
                      valueField="currency_code"
                      displayField="currency_code"
                      ref="refCurrencyCode"
                      :data="comboboxDataRemote.currency"
                      v-model="model.currency_code"
                      :initText="model.currency_code"
                      @selected="selectCurrency"
                      @blur="assignValueCurrency"
                      :dropdownWidth="600"
                      :class="['input-editor', 'currency-combo']"
                      :queryMode="'remote'"
                      :remoteFilter="true"
                      @comboboxLoadData="onCurrencyComboboxLoadData"
                      :disabled="viewing"
                    ></ms-combobox>
                  </div>

                  <label
                    class="text-nowrap bold ml-2"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                    >Tỷ giá</label
                  >

                  <div
                    class="ml-1 w100px"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                  >
                    <ms-number
                      v-model="model.exchange_rate"
                      :formatType="$ms.constant.FormatType.ExchangeRate"
                      :disabled="viewing"
                      @onActionBlur="onActionBlur"
                    ></ms-number>
                  </div>
                  <ms-button
                    :disabled="viewing || !model.accounting_object_id || !isViewInvoce"
                    text="Xem công nợ phải trả"
                    class="ml-2"
                    :hasBorder="true"
                    @click="showRefNoInvoice"
                    type="outline-button circle-button btn-multi-action-detail"
                  />
                  <menu-wrapper class="topnav-widget-more-container ml-2" :maxHeight="170">
                    <template #menu-button="{toggleMenu}">
                      <ms-button
                        :disabled="viewing"
                        text="Định khoản nhanh"
                        :hasBorder="true"
                        type="outline-button circle-button btn-multi-action"
                        @click="toggleMenu"
                        rightIcon="down-arrow-black"
                    /></template>
                    <template #menu-content>
                      <menu-item
                        v-for="(item, index) in accountingActions"
                        :key="index"
                        :seperatorBottom="item.seperatorBottom"
                        @click="clickQuickAccounting(item.id)"
                        >{{ item.text }}</menu-item
                      ></template
                    >
                  </menu-wrapper>
                </div>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 1 || selectedTab == 2">
                <ms-grid-editor
                  :ref="refDetail"
                  formId="plan-with-draw-detail"
                  :disabled="viewing"
                  :data="model.Detail"
                  v-model:list="model.Detail"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggersTab12"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configAccountingGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 3">
                <ms-grid-editor
                  :ref="refDetailOther"
                  formId="plan-with-draw-detail"
                  :disabled="viewing"
                  :data="model.BAWithdrawDetailTax"
                  v-model:list="model.BAWithdrawDetailTax"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggersTab3"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configTaxGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
            </template>
            <template v-slot:content-item>
              <div class="flex-column flex">
                <div class="toolbar-grid flex-between">
                  <div class="content-left">
                    <div class="item-tabs active">Hạch toán đồng thời</div>
                  </div>

                  <div class="flex-row flex-center">
                    <ms-button
                      type="icon-button"
                      leftIcon="update-down"
                      text="Cập nhật hạch toán đồng thời"
                      @click="generateParallel(true)"
                      :disabled="viewing"
                      class="update-btn"
                    />
                  </div>
                </div>
                <div class="flex d-flex">
                  <ms-grid-editor
                    formId="plan-with-draw-detail"
                    :disabled="viewing"
                    :data="model.Parallels"
                    v-model:list="model.Parallels"
                    ref="refDetailParallel"
                    class="flex-box"
                    idField="ref_detail_id"
                    greyTitle
                    :columns="columnsDataParalell"
                    :propsData="propsDataParalell"
                    @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                    :footer="true"
                    @updateBusiness="changeDataBusiness"
                    :changeTriggers="changeTriggers"
                    @onEditEventCellEditor="
                      (colIndex, rowIndex, $grid) => {
                        toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                      }
                    "
                    :name="'gridParallel'"
                    @copyDownRow="copyDownRow"
                    @copyActionClick="copyActionClick"
                    isCopyDataColumn
                    :lineBreak="this.dbOptions?.LineBreak ?? 1"
                    :configVoucherQuickEdit="configParallelGrid"
                    :isQuickEditVoucher="isQuickEditVoucher"
                    :itemRightClicks="itemRightClicks"
                    @afterRightClickAction="viewAccount(this)"
                  ></ms-grid-editor>
                </div>
              </div>
            </template>
          </ms-resize-screen>
        </div>
      </div>
    </template>
    <template v-slot:footer="{close}">
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
          <ms-button
            text="Cất"
            v-tooltip="'Cất (Ctrl + S)'"
            class="step-close"
            shortkey-target="Save"
            @click="commandClick($ms.constant.Command.SaveView)"
            v-if="this.editMode != this.$ms.constant.FormState.View"
          ></ms-button>
          <ms-button
            text="Hoãn"
            type="btn-custom"
            class="mr-footer-btn"
            v-tooltip="'Hoãn (Ctrl + U)'"
            shortkey-target="Postpone"
            @click="commandClick($ms.constant.Command.Postpone)"
            v-if="!viewing"
          ></ms-button>
        </div>
        <div class="flex-row" v-if="viewing">
          <ms-button
            text="Sửa"
            class="mr-footer-btn step-8-unposted"
            type="btn-custom"
            v-tooltip="'Sửa (Ctrl + E)'"
            shortkey-target="Edit"
            v-if="this.isShowEditAndPosted && !this.isFromCompareConvert"
            @click="onEditEvent"
            :disabled="offlineReady"
          ></ms-button>

          <ms-button
            text="Ghi sổ"
            title="Ghi sổ (Ctrl + G)"
            class="step-close"
            v-if="this.isShowEditAndPosted"
            shortkey-target="Posted"
            @click="commandClick($ms.constant.Command.Posted)"
            :disabled="offlineReady"
          ></ms-button>
          <!-- start -->
          <div class="flex-row" v-if="this.isShowUnPosted && isQuickEditVoucher" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              v-tooltip="'Cất (Ctrl + S)'"
              class="step-close"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>
            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              @click="commandClick($ms.constant.Command.Postpone)"
            ></ms-button>
          </div>
          <ms-button
            text="Sửa nhanh"
            title="Sửa nhanh"
            class="mr-footer-btn step-7-posted"
            type="btn-custom"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            shortkey-target="QuickEdit"
            @click="eventQuickEditVoucher"
          ></ms-button>
          <!-- end -->
          <ms-button
            text="Bỏ ghi"
            title="Bỏ ghi (Ctrl + B)"
            class="step-close"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            shortkey-target="UnPosted"
            @click="commandClick($ms.constant.Command.UnPosted)"
          ></ms-button>
        </div>

        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            class="btn-opacity max-height pl-1"
            @click="refresh"
            v-tooltip="'Nạp (Ctrl + R)'"
            shortkey-target="Refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-pos"
            classCustom="btn-opacity"
            @menuClick="clickItemHandle"
            :menuItems="buttonUtilities"
            isBtnFooterHelpFul
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>

          <div class="seperator-button"></div>

          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            class="max-height step-6-pos"
            classCustom="btn-opacity"
            isBtnFooterHelpFul
            @menuClick="printItemCLick"
            :menuItems="printMenu"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
            :disabled="!viewing"
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            class="btn-opacity max-height"
            :disabled="!viewing || isShowFromReport || stateApprove"
            @click="onApproveAction"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-unposted"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: $ms.constant.Command.Add})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
        </div>
        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            class="mr-1"
            shortkey-target="ArrowLeft"
            :disabled="!currentIndexBack"
            v-tooltip="'Trước'"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button
            text="Đóng"
            type="btn-custom"
            v-tooltip="'Đóng (Ctrl + Q)'"
            shortkey-target="Quit"
            class="mr-2"
            @click="close"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import {ModuleBaWithdraw, ModuleBATransfer, ModuleAccountingObject} from '@/stores/moduleConst';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import baseDetail from '@/views/base/baseDetail';
import {useBAWithDrawDetailData} from './BAWithDrawDetailData.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import MsInput from '../../../components/input/MsInput.vue';
import {useInitActionCombo} from '../../../commons/combobox/initActionCombo.js';
import budgetChapterAPI from '@/apis/di/budgetChapterAPI.js';
import accountingObjectAPI from '@/apis/di/accountingObjectAPI.js';
import budgetItemAPI from '@/apis/di/budgetItemAPI.js';
import bankInfoAPI from '@/apis/di/bankInfoAPI.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useCurrencyShowColumn} from '@/commons/gridColumn/CurrencyShowColumn.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import popupUtil from '@/commons/popupUtil';
import RefType from '@/commons/wildcards/constants/RefType.js';
import {useQuickAccountingVoucher} from '@/setup/utilities/quickAccountingVoucher.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import {useActionParallel} from '@/commons/gridColumn/ActionParallel.js';
import GLVoucherAPI from '@/apis/gl/gLVoucherAPI.js';
import {showConfirm, showError, showChooseOptionConfirm, showChooseOptionConfirmVertical} from '@/commons/globalMessage';
import {useCAReceiptSaleDetailData} from '@/views/sell/cAReceiptSale/CAReceiptSaleDetailData.js';
import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import {useCachePurchasePurposeComboConfig} from '@/commons/combobox/cacheCombo/cachePurchasePurposeComboConfig.js';
import MsTour from '@/components/tour/MsTour.vue';
import {useSelectRefNoInvoice} from '@/views/common/selectRefNoInvoice.js';

import {defineComponent, onMounted, reactive, ref, computed, getCurrentInstance, shallowRef} from 'vue';
import {useCopyNewVoucher} from '@/views/utility/commons/copyNewVoucher.js';
import {useValidateBudgetSourceAccount} from '@/views/utility/commons/validateBudgetSourceAccount.js';
import msResizeScreen from '@/components/resize-wrapper/MsResizeScreen.vue';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import AlertRiskCustomerVendorPopup from '@/views/tax/tARiskCustomerVendor/AlertRiskCustomerVendorPopup.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import _ from 'lodash';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MenuWrapper,
    MenuItem,
    MsTour,
    msResizeScreen,
    AlertRiskCustomerVendorPopup,
  },
  extends: baseDetailVoucher,
  name: 'BAWithDrawDetail',

  setup(props) {
    const titleCode = 'detail_popup_bawithdrawdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleBaWithdraw;
    const {showRefNoInvoice, isViewInvoce} = useSelectRefNoInvoice();
    // NHCUONG 23.06.2023: Các thông tin cho chứng từ tham chiếu
    const voucherReferenceItems = ref([]);
    const isAcceptValidateVoucherReference = ref(false);
    const refTypeAcceptVoucherReference = ref([
      proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
      proxy.$ms.constant.RefType.CAPayment,
      proxy.$ms.constant.RefType.CAPaymentPurchase,
      proxy.$ms.constant.RefType.CAPaymentFixedAsset,
      proxy.$ms.constant.RefType.CAPaymentVendor,
      proxy.$ms.constant.RefType.BAWithDraw,
      proxy.$ms.constant.RefType.BAWithdrawPurchase,
      proxy.$ms.constant.RefType.BAWithDrawFixedAsset,
      proxy.$ms.constant.RefType.BAWithdrawVendor,
      proxy.$ms.constant.RefType.GLGeneralVoucher,
      proxy.$ms.constant.RefType.BUTransferDeposit,
    ]);

    let layoutTagDetail = ref('BAWithDrawDetail');
    let layoutTagDetailOther = ref('BAWithDrawDetailTax');

    let quickSearchParam = reactive({
      AccountingObject: {
        titleSearch: 'đơn vị nhận',
        payload: {
          sort: 'is_employee,accounting_object_code',
        },
        module: ModuleAccountingObject,
        idField: 'accounting_object_id',
      },
      BankInfo: {
        titleSearch: 'Tìm nhanh tài khoản chi',
      },
    });

    /**
     * Config sửa nhanh chứng từ
     */
    const configAccountingGrid = [
      'description', // diễn giải
      'note', //ghi chú
      'contract_no', //hợp đồng
      'activity_name', // hoạt động
      'fund_code', //loại quỹ
      'statistic_code', // mã thống kê
      'topic_code', //đề tài
      'task_code', //nhiệm vụ
      'is_source_before_year', // nguồn năm trước
      'fund_structure_name', //cơ cấu vốn
      'project_activity_id', //hoạt động dự án
      'project_expense_id', //khoản chi dự án
      'project_expense_code',
    ];

    const configTaxGrid = ['description', 'accounting_object_name', 'accounting_object_address', 'company_tax_code'];

    const configParallelGrid = ['description'];

    /**
     * Lưu lại ref_no trước khi update phục vụ cập nhật lại refno_finance màn hình InvoiceBot_List
     * HMDUC2 02/01/2023
     */
    const refNoBeforeUpdate = ref('');
    const isShowRiskPopup = ref(false);
    const {validateRiskCustomerVendor, riskWarningMessage, isShowQuestionIcon} = useValidateControl({
      props,
    });
    proxy._gridDetails = {
      Detail: 'refDetail',
      Parallels: 'refDetailParallel',
      BAWithdrawDetailTax: 'refDetailOther',
    };

    //Có sử dụng nghiệp vụ Thuế không
    const useTA = ref(false);

    onMounted(() => {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      if (dbOptions && typeof dbOptions === 'object') {
        useTA.value = dbOptions.UseTA;
      }
      // if (proxy._formParam.IsInsuranceGenerateData) {
      //   useTA.value = !proxy._formParam.IsInsuranceGenerateData;
      // }
      if (proxy._formParam?.isCreateFromInbot) {
        quickSearchParam.AccountingObject.dataFromInvoiceInbot = proxy._formParam?.dataQuickAdd;
      }

      const current = proxy.$store.getters['context/Context'];
      cacheAccountKey.value = 'BAWithDrawDetail_' + current.DatabaseId;
    });

    // sự kiện chọn combo cấp phát
    const selectedMethodDistributeType = ({newData}) => {
      if (newData) {
        proxy.model.method_distribute_name = newData.enumText;
      } else {
        proxy.model.method_distribute_name = '';
      }
    };

    // sự kiện combo tài khoản đơn vị nhận tiền
    const accountingObjectBankSelected = ({newData}) => {
      if (newData) {
        proxy.model.accounting_object_bank_name = newData.bank_name;
      } else {
        proxy.model.accounting_object_bank_name = '';
      }
    };

    // khởi tạo dữ liệu
    const {
      toggleAbove,
      toggleAboveHandler,
      columnParallel,
      selectedTab,
      currentLayout,
      projectComboConfig,
      accountComboMostDetailConfig,
      budgetSourceComboConfig,
      budgetSubKindItemComboConfig,
      budgetItemComboConfig,
      budgetSubItemComboConfig,
      budgetDetailItemComboConfig,
      budgetKindItemComboConfig,
      submitQuickAdd,
      bankAccountComboConfig,
      activityComboConfig,
      statisticComboConfig,
      accountingObjectComboConfig,
      buttonPrints,
      comboboxLoadData,
      budgetChapterComboConfig,
      budgetFeesComboConfig,
      TaskComboConfig,
      purchasePurposeComboConfig,
      typeOfFundComboConfig,
      contractComboConfig,
      buttonUtilities,
      accountComboParalellConfig,
      fundStructureComboConfig,
      budgetProvideComboConfig,
      topicComboConfig,
      accountComboConfig,
      copyDownRowExtend,
    } = useBAWithDrawDetailData();

    const {selectedBank, selectedAccountingObject, onBlurActionDatePicker, viewAccount} = useInforCommons();
    // Validate tài khoản và nguồn
    const {onPosted, customUnPostedSuccess} = useValidateBudgetSourceAccount();

    /**
     * Định khoản nhanh
     * NXCHIEN 10.07.2022
     */
    const {refType, clickQuickAccounting, accountingActions, saveAsNewAutoBusiness} = useQuickAccountingVoucher({
      gridDetails: proxy._gridDetails,
    });

    const subSystemCode = proxy.$ms.constant.SubSystemCode.BAWithdraw;

    /**
     * Lấy tất cả định khoản nhanh theo loại chứng từ
     * NCPHUOC 05/07/2022
     */
    refType.value = RefType.BAWithDraw;

    //pilot case 1 grid
    const selectedTabHandler = value => {
      switch (value) {
        case 1:
          layoutTagDetail.value = 'BAWithDrawDetail';
          currentLayout.value = 'BAWithDrawDetail';
          break;
        case 2:
          layoutTagDetail.value = 'BAWithDrawDetailSta';
          currentLayout.value = 'BAWithDrawDetailSta';
          break;
        case 3:
          layoutTagDetailOther.value = 'BAWithDrawDetailTax';
          currentLayout.value = 'BAWithDrawDetailTax';
          proxy.initLayoutDetailOther(); //init lại tránh trường hợp lệch cột tiền
          break;
      }
      selectedTab.value = value;
    };

    const comboboxDataRemote = reactive({});

    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      totalAmountComputed,
      assignValueCurrency,
      onActionBlur,
      currencyCode,
      isFirst,
    } = useCurrencyCombo(
      comboboxDataRemote,
      comboboxLoadData,
      proxy,
      'Detail',
      'Parallels',
      'BAWithdrawDetailTax',
      customSelectCurrency,
    );

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * NTLOC 12.06.2022
     * dtnga3 (20.07.2022) check thêm dataField cột quy đổi, k làm ảnh hưởng các cột khác
     */
    function customColumns(columns) {
      isFirst.value = false;
      if (proxy.model.currency_code && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
        columns.forEach(item => {
          if (item.dataField == 'amount' || item.dataField == 'to_amount' || item.dataField == 'remain_amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
        proxy.columnsDataParalell.forEach(item => {
          if (item.dataField == 'amount' || item.dataField == 'to_amount' || item.dataField == 'remain_amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      } else {
        columns.forEach(item => {
          if (item.dataField == 'amount' || item.dataField == 'to_amount' || item.dataField == 'remain_amount') {
            item.visible = false;
          }
        });
      }
    }

    // khởi tạo column cho dropdown của combobox
    const {
      budgetChapterColumns,
      accountColumns,
      bankInfoColumns,
      bankColumns,
      accountingObjectCustomColumns,
      currencyColumns,
      statisticColumns,
    } = useComboboxColumns();

    const {
      cacheAccountDebitCombo,
      cacheAccountCreditCombo,
      cacheAccountTaxCreditCombo,
      cacheAccountDebitParalellCombo,
      cacheAccountCreditParalellCombo,
    } = useCacheAccountComboConfig();
    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    cacheAccountTaxCreditCombo.modelValueField = 'tax_account';
    cacheAccountDebitParalellCombo.modelValueField = 'debit_account';
    cacheAccountCreditParalellCombo.modelValueField = 'credit_account';
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();
    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();
    const {
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetDetailItemComboConfig,
    } = useCacheBudgetItemComboConfig();
    const {cacheProjectComboConfig} = useCacheProjectComboConfig();
    const {cacheActivityComboConfig} = useCacheActivityComboConfig();
    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();
    const {cacheBankInfoComboConfig, bankInfoCombo} = useCacheBankInfoComboConfig();
    const {cacheContractComboConfig} = useCacheContractComboConfig();
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();
    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();
    const {cachePurchasePurposeComboConfig} = useCachePurchasePurposeComboConfig();
    const {accountingObjectCombo} = useCacheAccountingObjectComboConfig();

    // func hỗ trợ load data combo
    // const { comboboxLoadData } = useRemoteCombobox();
    const {
      onBudgetChapterComboboxLoadData,
      onBankInfoComboboxLoadData,
      onAccountingObjectComboboxLoadData,
      projectExpenseComboConfig,
    } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);

    // Cấu hình các field của grid
    const propsData = {
      org_ref_no: {
        maxLength: 200,
      },
      description: {
        maxLength: 255,
      },
      amount: {
        max: proxy.$ms.constant.RangeOfNumber.Max,
      },
      amount_oc: {
        maxLength: 14,
      },
      inv_no: {
        maxLength: 20,
      },
      inv_type_code: {
        maxLength: 25,
      },
      inv_series: {
        maxLength: 20,
      },
      company_tax_code: {
        maxLength: 50,
      },
      accounting_object_name: {
        maxLength: 255,
      },
      accounting_object_address: {
        maxLength: 255,
      },
      quantity: {
        min: 0,
      },
      unitprice: {
        min: proxy.$ms.constant.RangeOfNumber.MinNegative,
        max: proxy.$ms.constant.RangeOfNumber.Max,
      },
      debit_account: cacheAccountDebitCombo,
      credit_account: cacheAccountCreditCombo,
      budget_source_name: cacheBudgetSourceComboConfig,
      budget_chapter_code: cacheBudgetChapterComboConfig,
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      budget_item_code: cacheBudgetItemComboConfig,
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      budget_detail_item_code: cacheBudgetDetailItemComboConfig, // tiết tiểu mục
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      task_code: cacheTaskComboConfig, // nhiệm vụ
      is_source_before_year: {},
      method_distribute_name: {
        enum: 'MethodDistributeType',
        modelValueField: 'method_distribute_type',
      },
      cash_withdraw_type_name: {
        enum: 'CashWithDrawType',
        modelValueField: 'cash_withdraw_type_id',
      },
      project_code: cacheProjectComboConfig, // CTMT, dự án
      activity_name: cacheActivityComboConfig, // hoạt động
      budget_fees_code: cacheBudgetFeesComboConfig, // phí, lệ phí
      accounting_object_code: accountingObjectComboConfig, // đối tượng
      statistic_code: cacheStatisticComboConfig, // mã thống kê
      bank_account: cacheBankInfoComboConfig,
      tax_rate: {
        enum: 'TaxRateInventory',
        modelValueField: 'tax_rate',
      },
      turn_over: {},
      inv_type: {
        enum: 'InvType',
        modelValueField: 'inv_type',
      },
      purchase_purpose_code: cachePurchasePurposeComboConfig,
      fund_code: cacheFundComboConfig, // loại quỹ
      contract_no: cacheContractComboConfig, // hợp đồng
      fund_structure_name: cacheFundStructureComboConfig, // cơ cấu vốn
      budget_provide_code: cacheBudgetProvideComboConfig, // mã dự phòng
      topic_code: cacheTopicComboConfig,
      project_expense_code: projectExpenseComboConfig,
      rowAction: ['Insert', 'Delete'],
    };

    // config grid hạch toán đồng thời
    var propsDataParalell = Object.assign({}, propsData);
    propsDataParalell.debit_account = cacheAccountDebitParalellCombo;
    propsDataParalell.credit_account = cacheAccountCreditParalellCombo;

    //#region config ẩn hiện cột và sự kiện liên quan đến combo Loại tiền
    const {columnsDataParalell} = useCurrencyShowColumn(proxy, columnParallel);

    // Cập nhật lại tổng tiền khi xóa dòng dữ liệu chi tiết
    const {
      changeDataBusinessCommon,
      defaultData,
      getDataDefault,
      toggleAboveHandlerGrid,
      bindDefaultData,
      onGridStyleColumn,
      onClickCKC,
      copyDownRow,
      copyActionClick,
      assignDataEmptyToParallel,
    } = useActionGridEditor(proxy);

    getDataDefault(proxy.$ms.constant.RefType.BAWithDraw);

    //Config quickAdd người nộp
    const quickAddMultiItems = ref([
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Khách hàng, nhà cung cấp',
      },
      {
        valueField: 'EmployeeDetail',
        displayField: 'Cán bộ',
      },
    ]);

    const cacheAccountKey = ref('');

    /**
     * Custom gọi hàm sinh dữ liệu
     */
    function customVoucherLoadData(result) {
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsGenerateData &&
        (proxy.editMode === proxy.$ms.constant.FormState.Add || proxy.editMode === proxy.$ms.constant.FormState.Edit)
      ) {
        Object.assign(result, {
          Id: proxy._formParam.data.ref_id,
          ParamModeAdd: JSON.stringify({
            RefTypeKey: proxy.$ms.constant.RefType.BAWithDraw,
          }),
          IsSyncData: proxy._formParam.data.IsSyncData,
          action: 'DataVoucher',
        });
      } else {
        proxy.super('customVoucherLoadData', baseDetailVoucher, result);
      }
    }

    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);
      // Custom thêm thì switch case ở đây.
      let amountOc = 0;
      let quantity = 0;

      switch (dataField) {
        case 'turn_over': // Giá tính thuế
          if ($grid.columnx.find(x => x.dataField == 'turn_over')) {
            let taxOver = $grid.dataView[rowIndex].turn_over || 0;
            if (taxOver) {
              let taxRate = $grid.dataView[rowIndex].tax_rate || 0;
              //Tính tiền thuế = Giá tính thuế * thuế suất * tỷ giá (nếu loại tiền khác VND) và cập nhật lên grid
              let taxAmountValue;
              if (taxRate == proxy.$ms.constant.TaxRateInventory.NoSelected) {
                taxAmountValue = 0;
              } else {
                taxAmountValue = (taxRate * taxOver) / 100;
              }
              $grid.dataView[rowIndex].tax_amount = taxAmountValue;
            }
          }
          break;
        case 'tax_rate':
          if ($grid.columnx.find(x => x.dataField == 'tax_rate')) {
            let taxRate1 = $grid.dataView[rowIndex].tax_rate || 0;
            if (taxRate1) {
              let taxOver = $grid.dataView[rowIndex].turn_over || 0;
              //Tính tiền thuế = giá tính thuế * thuế suất * tỷ giá (nếu loại tiền khác VND) và cập nhật lên grid
              let taxAmountValue;
              if (taxRate1 == proxy.$ms.constant.TaxRateInventory.NoSelected) {
                taxAmountValue = 0;
              } else {
                taxAmountValue = (taxRate1 * taxOver) / 100;
              }
              $grid.dataView[rowIndex].tax_amount = taxAmountValue;
            }
          }
          break;
        case 'accounting_object_code':
          callbackUpdateRow(
            { accounting_object_name: metaData.accounting_object_name, 
              company_tax_code: metaData.company_tax_code,
              accounting_object_address: metaData.address 
            },
            rowIndex,
          );
          break;
        case 'quantity':
          amountOc = $grid.dataView[rowIndex]['amount'] || 0;
          if (!tracking.newVal) {
            callbackUpdateRow({unitprice: 0}, rowIndex);
          } else callbackUpdateRow({unitprice: amountOc / tracking.newVal}, rowIndex);
          break;
        case 'amount':
        case 'amount_oc':
          amountOc = $grid.dataView[rowIndex]['amount'] || 0;
          quantity = $grid.dataView[rowIndex]['quantity'] || 0;
          if (!quantity) {
            callbackUpdateRow({unitprice: 0}, rowIndex);
          } else callbackUpdateRow({unitprice: amountOc / quantity}, rowIndex);
          break;
        default:
          break;
      }
    };

    /**
     * Cập nhật đơn giá tính theo số tiền quy đổi
     */
    function customSelectCurrency() {
      let exchangeRate = proxy.model.exchange_rate;
      proxy.model.Detail.forEach(x => {
        if (x.state != proxy.$ms.constant.ModelState.Empty && x.quantity) {
          x.unitprice = (x.amount_oc * exchangeRate) / x.quantity;
        }
        if (x.state == proxy.$ms.constant.ModelState.None) {
          x.state = proxy.$ms.constant.ModelState.Update;
        }
      });
    }

    async function bindData(data) {
      if (data.ref_id || proxy._formParam.mode == proxy.$ms.constant.FormState.Add) {
        data.increment_ref_no = null;
        data.posted_date = data.posted_date || proxy.postedDate;
        data.ref_date = data.ref_date || proxy.postedDate;
        data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
        currencyCode.value = data.currency_code;
        data.exchange_rate = data.exchange_rate || 1;
        data.showFrom = 'BAWithDrawTab';
        data.total_amount = data.total_amount || 0;

        // NHCUONG 23.06.2023: Bổ sung thêm chứng từ tham chiếu
        if (data.VoucherReferences && data.VoucherReferences.length > 0) {
          setVoucherReferenceInfo(
            data.VoucherReferences.map(item => ({
              ...item,
              ref_id: item.to_ref_id,
              ref_no: item.to_ref_no,
              ref_type: item.to_ref_type,
              budget_source_id: item.from_budget_source_id,
              budget_kind_item_code: item.from_budget_kind_item_code,
              budget_sub_kind_item_code: item.from_budget_sub_kind_item_code,
              budget_chapter_code: item.from_budget_chapter_code,
              budget_item_code: item.from_budget_item_code,
              budget_sub_item_code: item.from_budget_sub_item_code,
              task_id: item.from_task_id,
              statistic_id: item.from_statistic_id,
              project_id: item.from_project_id
            }))
          );
        } else {
          setVoucherReferenceInfo([]);
        }
        isAcceptValidateVoucherReference.value = false;

        proxy.super('bindData', baseDetailVoucher, data);
        // sinh hạch toán đồng thời
        if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
          proxy.model.IsGen = true;
          proxy.model.withdraw_ref_id = proxy._formParam.data.ref_id;
          await proxy.generateParallel(true, true);
          assignDataEmptyToParallel(proxy);
        }
        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
        if (proxy.viewing) {
          if (proxy.model.is_posted) {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('posted') || x.state.includes('default'));
          } else {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('unposted') || x.state.includes('default'));
          }
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
        }
        // HMDUC2: Lưu lại biến ref_no trước khi update
        proxy.refNoBeforeUpdate = JSON.stringify(data?.ref_no);
      }
    }

    //Ovrride để Gán lại tham số trước khi save
    function getSaveData(mode, action) {
      var data = proxy.super('getSaveData', baseDetailVoucher, mode, action);

      data.ref_type = proxy.$ms.constant.RefType.BAWithDraw;
      data.ref_type_name = proxy.$t('i18nEnum.RefType.BAWithDraw');

      if (!data.bu_commitment_request_ref_no) {
        data.bu_commitment_request_id = null;
      }

      // những dòng không còn trong data mới thì đưa state về 3 là delete
      if (
        proxy.editMode == proxy.$ms.constant.FormState.Edit &&
        proxy.oldDataItem.Parallels &&
        proxy.oldDataItem.Parallels.length
      ) {
        proxy.oldDataItem.Parallels.forEach(item => {
          // push những item không có trong data mới vào data mới đồng thời gán state
          if (
            data.Parallels &&
            data.Parallels.length &&
            !data.Parallels.find(x => x.ref_detail_id == item.ref_detail_id)
          ) {
            item.state = proxy.$ms.constant.ModelState.Delete;
            data.Parallels.push(item);
          }
        });
      }

      // NHCUONG 23.06.2023: Bổ sung thêm lưu chứng từ tham chiếu
      if (voucherReferenceItems.value.length > 0) {
        const refDetailIds = voucherReferenceItems.value.map(item => item.from_ref_detail_id);

        const voucherReferences = proxy.model.Detail.filter(item => {
          if (refDetailIds.includes(item.ref_detail_id)) {
            const voucherReference = voucherReferenceItems.value.find(
              vourcher => vourcher.from_ref_detail_id === item.ref_detail_id,
            );
            if (
              voucherReference &&
              voucherReference.budget_source_id === item.budget_source_id &&
              voucherReference.budget_kind_item_code === item.budget_kind_item_code &&
              voucherReference.budget_sub_kind_item_code === item.budget_sub_kind_item_code &&
              voucherReference.budget_chapter_code === item.budget_chapter_code &&
              voucherReference.budget_item_code === item.budget_item_code &&
              voucherReference.budget_sub_item_code === item.budget_sub_item_code &&
              voucherReference.task_id === item.task_id &&
              voucherReference.statistic_id === item.statistic_id &&
              voucherReference.project_id === item.project_id
            )
              return item;
          }
        });
        if (voucherReferences.length > 0) {
          data.VoucherReferences = voucherReferences.map(item => ({
            ...item,
            to_ref_id: voucherReferenceItems.value[0]?.ref_id,
            to_ref_no: voucherReferenceItems.value[0]?.ref_no,
            to_ref_type: voucherReferenceItems.value[0]?.ref_type,
            from_budget_source_id: item.budget_source_id,
            from_budget_kind_item_code: item?.budget_kind_item_code,
            from_budget_sub_kind_item_code: item?.budget_sub_kind_item_code,
            from_budget_chapter_code: item?.budget_chapter_code,
            from_budget_item_code: item?.budget_item_code,
            from_budget_sub_item_code: item?.budget_sub_item_code,
            from_task_id: item?.task_id,
            from_statistic_id: item?.statistic_id,
            from_project_id: item?.project_id,
            from_ref_detail_id: item?.ref_detail_id,
          }));
        } else {
          data.VoucherReferences = [];
        }
      } else {
        data.VoucherReferences = [];
      }
      data.IsAcceptValidateVoucherReference = isAcceptValidateVoucherReference.value;
      isAcceptValidateVoucherReference.value = false;
      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.isSaveOffline = proxy?.offlineReady;
      if (data.isSaveOffline && !data.state) {
        data.state = proxy.$ms.constant.FormState.Add;
      }
      // biến để check lưu bảng reference inbot
      data.IsInvoiceInbotReference = true;
      return data;
    }

    const {clickItemCopyVoucher} = useCopyNewVoucher(proxy, 'Detail');

    /**
     * Xử lý khi click button Tiện ích
     * dtnga3 (22.07.2022)
     */
    const clickItemHandle = item => {
      switch (item.command) {
        case proxy.$ms.constant.Command.Add:
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          proxy.add({mode: proxy.$ms.constant.FormState.Add});
          break;
        case proxy.$ms.constant.Command.Duplicate:
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          item.form = item.form ?? 'BAWithDrawDetail';
          item.refType = item.refType ?? proxy.$ms.constant.RefType.BAWithDraw;
          clickItemCopyVoucher(item);
          break;
        case proxy.$ms.constant.Command.Delete:
          proxy.delete(proxy.model);
          break;
        case proxy.$ms.constant.Command.ViewAccount:
          viewAccount(proxy);
          break;
        case proxy.$ms.constant.Command.Copy:
          proxy.clickCopyVoucher();
          break;
        case proxy.$ms.constant.Command.AddAutoBusiness:
          saveAsNewAutoBusiness();
          break;
        //Hạch toán chi phí lương
        case proxy.$ms.constant.Command.GenerateDataFundSalary:
          generateGLVoucher(true);
          break;
        //Hạch toán chi phí bảo hiểm
        case proxy.$ms.constant.Command.GenerateDataFundInsurance:
          generateGLVoucher(false);
          break;
        case proxy.$ms.constant.Command.ViewAdvanceBalance:
          getAdvanceBalance();
          break;
      }
      proxy.pushTrans(item.command);
    };
    /**
     * Hàm sinh hạch toán chi phí lương
     * NNLINH 03.11.2022
     */
    async function generateGLVoucher(isFundSalary) {
      // check quyền Thêm (vqphong - 14/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
      let details = {...proxy.model};
      details.IsGenerateData = true;
      let dataTrans = await GLVoucherAPI.getDataByRelationRefId(details.ref_id);
      if (dataTrans) {
        let mes = proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncFundSalaryContent');
        showConfirm(
          mes.format('Chi tiền gửi', dataTrans.ref_no),
          proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherTitle'),
        ).then(answer => {
          switch (answer) {
            case true:
              // check quyền Sửa (vqphong - 12/12/2022)
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
              details.IsSyncData = true;
              popupUtil.show('GLGeneralVoucherDetail', {
                mode: proxy.$ms.constant.FormState.Edit,
                formApproveName: 'ApproveVoucherGLVoucherTab',
                // id: proxy.model.ref_id,
                refType: proxy.model.ref_type,
                IsFundSalary: isFundSalary,
                data: details,
                options: {
                  submit: data => {
                    proxy.view({
                      id: proxy.model.ref_id,
                      mode: proxy.$ms.constant.FormState.View,
                    });
                  },
                },
              });
              break;
            case false:
              break;
          }
        });
      } else {
        popupUtil.show('GLGeneralVoucherDetail', {
          mode: proxy.$ms.constant.FormState.Add,
          formApproveName: 'ApproveVoucherGLVoucherTab',
          refType: proxy.model.ref_type,
          data: details,
          IsFundSalary: isFundSalary,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      }
    }
    /**
     * Config tùy chỉnh giao diện
     * HQMINH 22.07.2022
     */
    const getConfigLayout = () => {
      let layouts = [
        {tag: 'BAWithDrawDetail', name: 'Hạch toán'},
        {tag: 'BAWithDrawDetailSta', name: 'Thống kê'},
        {tag: 'BAWithDrawDetailTax', name: 'Thuế'},
      ];

      return {layouts};
    };

    /**
     * Xử lý lưu lại options tài khoản chi để sau mở form thì tự khắc binding lên control
     * HQMINH 25.07.2022
     */
    const saveSuccess = async (result, saveParam, action) => {
      const me = proxy;
      me.super('saveSuccess', baseDetailVoucher, result, saveParam, action);

      //Gán giá trị vào model localStorage
      if (saveParam.Model) {
        const localStorageValue = {};

        localStorageValue.BAWithDrawDetail_BankAccount = saveParam.Model.bank_account || '';

        localStorageValue.BAWithDrawDetail_BankName = saveParam.Model.bank_name || '';

        localStorage.setItem(cacheAccountKey.value, JSON.stringify(localStorageValue));
      }
    };
    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    /**
     * Xử lý Binding dữ liệu khi mở form add
     * HQMINH 25.07.2022
     * dtnga3 (29.07.2022) gọi hàm cha để thực hiện nghiệp vụ chung
     */
    const beforeBinding = (data, mode) => {
      const me = proxy;
      me.super('beforeBinding', baseDetailVoucher, data, mode);
      if (
        mode === me.$ms.constant.FormState.Add &&
        me.$ms.commonFn.isJson(localStorage.getItem(cacheAccountKey.value))
      ) {
        const localStorageData = JSON.parse(localStorage.getItem(cacheAccountKey.value));

        if (!(proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData)) {
          data.bank_account =
            localStorageData && localStorageData.BAWithDrawDetail_BankAccount
              ? localStorageData.BAWithDrawDetail_BankAccount
              : '';
          data.bank_name =
            localStorageData && localStorageData.BAWithDrawDetail_BankName
              ? localStorageData.BAWithDrawDetail_BankName
              : '';
        }
      }
    };

    /**
     * Gán dữ liệu mặc định vào grid
     * dtnga3 (25.07.2022)
     */
    function customDefaultData($grid, me, rowIndex) {
      if ($grid.dataView[rowIndex].state == me.$ms.constant.ModelState.Empty) {
        $grid.dataView[rowIndex].state = me.$ms.constant.ModelState.Insert;
        //Loại hóa đơn
        if (me.model.inv_type) {
          $grid.dataView[rowIndex].inv_type = me.model.inv_type;
        } else {
          $grid.dataView[rowIndex].inv_type = me.$ms.constant.InvType.InvoiceGTGT;
        }
        //Số lượng
        $grid.dataView[rowIndex].quantity = me.model.quantity || 0;

        //Địa chỉ
        if (me.model.accounting_object_address) {
          $grid.dataView[rowIndex].accounting_object_address = me.model.accounting_object_address;
        } else {
          $grid.dataView[rowIndex].accounting_object_address = '';
        }
        //Mã số thuế
        if (me.model.company_tax_code) {
          $grid.dataView[rowIndex].company_tax_code = me.model.company_tax_code;
        } else {
          $grid.dataView[rowIndex].company_tax_code = '';
        }
        //Đối tượng
        if (me.model.accounting_object_code) {
          $grid.dataView[rowIndex].accounting_object_id = me.model.accounting_object_id;
          $grid.dataView[rowIndex].accounting_object_code = me.model.accounting_object_code;
        } else {
          $grid.dataView[rowIndex].accounting_object_id = '';
          $grid.dataView[rowIndex].accounting_object_code = '';
        }
        //Đối tượng khác
        if (me.model.accounting_object_name) {
          $grid.dataView[rowIndex].accounting_object_name = me.model.accounting_object_name;
        } else {
          $grid.dataView[rowIndex].accounting_object_name = '';
        }
      }
    }

    /**
     * Override Trả về Danh sách map từ tên các trường Chi Tiết theo
     * dtnga3 (25.07.2022)
     */
    function getMapDetailName() {
      let res = proxy.super('getMapDetailName', baseDetailVoucher);
      // delete res.is_detail_by_inventory_item;
      return res;
    }

    const {configColumnParalell} = useActionParallel();

    /**
     * Override Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * dtnga3 (01.08.2022)
     */
    function getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return configColumnParalell;
    }
    /**
     * Override từ base
     * Cập nhật danh sách bên ngoài sau khi xóa bản ghi liên quan bên trong màn hình chi tiết
     * @param {*} param
     * NVTUAN1 26.07.2022
     */
    function afterDeleteRelation(param) {
      const me = this;
      if (param && Array.isArray(param) && param.length) {
        let dataParam = param[0];
        let moduleValue = '';
        switch (dataParam.RefType) {
          //Tiền chuyển đi
          case me.$ms.constant.RefType.BATransferWithDraw:
            moduleValue = ModuleBATransfer;
            break;
          default:
            break;
        }

        if (moduleValue) {
          me.$store.dispatch(`${moduleValue}/updateAfterDeleteRelation`, param);
        }
      }
    }

    /**
     * Xử lý bind data khi sinh chứng từ nộp thuế
     * NHANH3 1.11.2022
     */
    async function beforeBindData(dataModel) {
      const me = proxy;
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsPayIncomeTax &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });
        //Trường hợp sinh từ nộp thuế
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.ref_date = proxy.postedDate;
        me.model.posted_date = proxy.postedDate;
        me.model.IsPayIncomeTax = true;
        me.model.ref_type = data.ref_type;
        me.model.BAWithdrawDetailTax = [];
        me.model.BAWithdrawDetailTax.push(me.model.Detail[0]);
        me.model.Parallels = [];
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = data.currency_code;
        me.model.Detail.forEach(e => {
          //#region Gắn lại thông tin MLNS ngầm định
          // Nguồn
          if (me.dbOptions.DefaultBudgetSourceID) {
            e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
            e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
            // lấy thêm DefaultBudgetSourceGroupPropertyType
            e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
          }

          // Chương
          if (me.dbOptions.DefaultBudgetChapterCode) {
            e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
            e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
          }

          // Loại
          if (me.dbOptions.DefaultBudgetKindItemCode) {
            e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
            e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
          }

          // Khoản
          if (me.dbOptions.DefaultBudgetSubKindItemCode) {
            e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
            e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
          }

          // nghiệp vụ
          if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
            e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
            e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
              formatType: 100,
              enumName: 'CashWithDrawType',
            });
          }

          // Hình thức cấp phát
          if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
            e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
            e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
              formatType: 100,
              enumName: 'MethodDistributeType',
            });
          }
          // Loại quỹ
          if (me.dbOptions.DefaultFundID) {
            e.fund_id = me.dbOptions.DefaultFundID;
            e.fund_code = me.dbOptions.DefaultFundCode;
          }
          //#endregion
        });
      }

      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsInsuranceGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });

        //Trường hợp sinh từ nộp bảo hiểm
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.ref_date = data.ref_date;
        (me.model.pa_from_month = proxy._formParam.pa_from_month),
          (me.model.pa_to_month = proxy._formParam.pa_to_month),
          (me.model.pa_year = proxy._formParam.pa_year),
          (me.model.Parallels = []);
        me.model.is_pay_insurance = true;
        me.model.ref_type = data.ref_type;
        me.model.posted_date = data.ref_date;
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = data.currency_code;

        // nghiệp vụ
        let cash_withdraw_type_id = null,
          cash_withdraw_type_name = null;
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          cash_withdraw_type_id = me.$ms.constant.CashWithDrawType.Expense;
          cash_withdraw_type_name = me.$ms.format.formatData(me.$ms.constant.CashWithDrawType.Expense, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        let method_distribute_type = null,
          method_distribute_name = null;
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }

        //Bind lại hình thức cấp phát, nghiệp vụ
        me.model.Detail.forEach(e => {
          e.cash_withdraw_type_id = cash_withdraw_type_id;
          e.cash_withdraw_type_name = cash_withdraw_type_name;
          e.method_distribute_type = method_distribute_type;
          e.method_distribute_name = method_distribute_name;
        });
        await proxy.generateParallel(true, true);
      }

      // Sinh chứng từ nộp thuế NHANH3 6.1.2023
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsPayTax &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        // let data = await proxy.loadData('New', {
        //   mode: proxy.$ms.constant.FormState.Add,
        // });
        //Trường hợp sinh từ nộp thuế
        me.model = proxy._formParam.data;
        me.model.ref_no = dataModel.ref_no;
        me.model.ref_date = proxy.postedDate;
        me.model.posted_date = proxy.postedDate;
        me.model.Parallels = [];
        me.model.ref_type = dataModel.ref_type;
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = dataModel.currency_code;
        me.model.Detail.forEach(e => {
          //#region Gắn lại thông tin MLNS ngầm định
          // Nguồn
          if (me.dbOptions.DefaultBudgetSourceID) {
            e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
            e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
            // lấy thêm DefaultBudgetSourceGroupPropertyType
            e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
          }

          // Chương
          if (me.dbOptions.DefaultBudgetChapterCode) {
            e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
            e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
          }

          // Loại
          if (me.dbOptions.DefaultBudgetKindItemCode) {
            e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
            e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
          }

          // Khoản
          if (me.dbOptions.DefaultBudgetSubKindItemCode) {
            e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
            e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
          }

          // nghiệp vụ
          if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
            e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
            e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
              formatType: 100,
              enumName: 'CashWithDrawType',
            });
          }

          // Hình thức cấp phát
          if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
            e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
            e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
              formatType: 100,
              enumName: 'MethodDistributeType',
            });
          }
          // Loại quỹ
          if (me.dbOptions.DefaultFundID) {
            e.fund_id = me.dbOptions.DefaultFundID;
            e.fund_code = me.dbOptions.DefaultFundCode;
          }
          //#endregion
        });
      }
    }

    /**
     * Hàm gửi tham số Report lên BE để in
     * NBTIN 1.11.2022
     * Modified by dhan 17/11/2022: Bổ sung thêm điều kiện gán param trước khi truyền dữ liệu
     */
    function getCustomReportParams(reportId) {
      let param = {
        ref_type: proxy.$ms.constant.RefType.BAWithDraw,
        ref_id: proxy.model.ref_id,
      };

      //Nếu kiểm tra là các chứng từ
      if (
        reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_BIDV['157'] ||
        reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_BIDV['158'] ||
        reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_VCB['157'] ||
        reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_Agribank['157'] ||
        reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_VCB['159']
      ) {
        param = {
          ListRefIDs: proxy.model.ref_id,
        };
      }
      //riêng mẫu viettinbank dùng store theo cấu trúc param truyền vào khác
      else if (reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_Viettinbank['157']) {
        param = {
          ListParam: '[' + JSON.stringify(param) + ']',
        };
      } else if (reportId == proxy.$ms.constant.ReportIDCodeCT.Report_Id_Viettinbank['159']) {
        param = {
          ref_type: proxy.$ms.constant.RefType.BAWithDrawFixedAsset,
          ref_id: proxy.model.ref_id,
        };
        param = {
          ListParam: '[' + JSON.stringify(param) + ']',
        };
      }

      return param;
    }
    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.step-1',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        key: 1,
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.step-2',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.setting-small',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.ic-question',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },

      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Thêm nội dung chi tiền gửi`,
      },

      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Xóa nội dung chi tiền gửi`,
      },

      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Nhấn Cất để lưu thông tin`,
      },
      {
        target: '.step-5-pos',
        header: {
          title: 'Tiện ích',
        },
        state: ['posted', 'unposted'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ mới, Xem số dư tài khoản,...',
      },
      {
        target: '.step-6-pos',
        header: {
          title: 'Chức năng In',
        },
        state: ['posted', 'unposted'],
        content: `Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô`,
      },
      {
        target: '.step-7-posted',
        header: {
          title: 'Sửa nhanh',
        },
        state: ['posted'],
        content: `Thực hiện sửa một số thông tin chung trên chứng từ`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Bỏ ghi',
        },
        state: ['posted'],
        content: `Bỏ ghi sổ chứng từ để sửa hoặc xóa chứng từ`,
      },
      {
        target: '.step-7-unposted',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['unposted'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-8-unposted',
        header: {
          title: 'Sửa',
        },
        state: ['unposted'],
        content: `Sửa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Ghi sổ',
        },
        state: ['unposted'],
        content: `Ghi sổ chứng từ hiện thời`,
      },
    ]);

    /**
     * Event nút Sửa
     * vqphong - 13/12/2022
     */
    const onEditEvent = () => {
      // Check quyền Sửa (vqphong - 12/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
      proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
    };

    /**
     * Custom diễn giải theo đơn vị
     * pqkhanh 24.02.2023
     */
    const selectedAccountingObjectBAWithDraw = ({newData}, me) => {
      selectedAccountingObject({newData}, me);
      
      if (newData) {
        // nếu đơn vị có tên là misa
        if (
          (proxy.editMode === proxy.$ms.constant.FormState.Add ||
            proxy.editMode === proxy.$ms.constant.FormState.Edit) &&
          proxy.model.accounting_object_name.toLowerCase().includes('misa')
        ) {
          proxy.model.journal_memo = `Mã QHNS: ${proxy.dbOptions.CompanyCode}; Số HĐ: ...; Số điện thoại người thanh toán : ....; Thanh toán tiền mua phần mềm:...`;
        }

        // xử lý gán vào đối tượng grid tab Thuế
        let dataGrid = me.$refs['refDetailOther']?.getData();
        if (dataGrid && dataGrid.length > 0) {
          dataGrid.forEach(item => {
            if (item.state != me.$ms.constant.ModelState.Empty) {
              item.accounting_object_code = newData.accounting_object_code;
              item.accounting_object_id = newData.accounting_object_id;
              item.accounting_object_name = newData.accounting_object_name;
              item.accounting_object_address = newData.address;
              item.company_tax_code = newData.company_tax_code;
            }
            if (item.state === me.$ms.constant.ModelState.None) {
              item.state = me.$ms.constant.ModelState.Update;
            }
          });
        }
      }
    };

    /**
     * Xem số dư tạm ứng
     * NNLINH 10.05.2023
     */
    function getAdvanceBalance() {
      popupUtil.show('ViewAdvanceBalance', {
        postedDate: proxy.model.posted_date,
      });
    }

    /**
     * Có hiển thị chọn tham chiếu đến chứng từ hay không
     * @author NHCUONG 23.06.2023
     */
    const isShowVoucherReference = computed(() => {
      return refTypeAcceptVoucherReference.value.includes(refType.value);
    });

    /**
     * Hiển thị form tham chiếu Phiếu thu
     * @author NHCUONG 23.06.2023
     */
    function showFormVoucherReference() {
      if (!proxy.viewing)
        popupUtil.show('VoucherReference', {
          postedDate: proxy.model.posted_date,
          RefTypeView: getRefTypeView(),
          options: {
            submit: this.callbackChooseItem.bind(this),
          },
        });
    }

    /**
     * Lấy ref type tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function getRefTypeView() {
      let refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
      switch (refType.value) {
        case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
          refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
          break;
        case proxy.$ms.constant.RefType.BAWithDraw:
        case proxy.$ms.constant.RefType.BAWithdrawPurchase:
        case proxy.$ms.constant.RefType.BAWithDrawFixedAsset:
        case proxy.$ms.constant.RefType.BAWithdrawVendor:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
        case proxy.$ms.constant.RefType.GLGeneralVoucher:
          refTypeView = proxy.$ms.constant.DefaultValue.All;
          break;
        case proxy.$ms.constant.RefType.BUTransferDeposit:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
      }
      return refTypeView;
    }

    /**
     * Sự kiện khi chọn chứng từ tham chiếu từ grid danh sách
     * @author NHCUONG 23.06.2023
     */
    function callbackChooseItem(items) {
      setVoucherReferenceInfo(items);
      let grid = getGridDetail();
      if (grid) {
        initNewData(grid);
      }
    }

    /**
     * Gán thông tin tham chiéu
     * @author NHCUONG 23.06.2023
     */
    function setVoucherReferenceInfo(data) {
      voucherReferenceItems.value = data;
    }

    /**
     * Lấy grid detail
     * @NHCUONG 23.06.2023
     */
    function getGridDetail() {
      let keys = Object.keys(proxy._gridDetails);
      if (keys && keys.length > 0) {
        let refName = proxy._gridDetails[keys[0]];
        let gridRef = proxy.$refs[refName];
        if (gridRef) {
          return gridRef;
        }
        return null;
      }
      return null;
    }

    /**
     * Gán tiền cho dòng đầu tiên
     * @author NHCUONG 23.06.2023
     */
    function initNewData(grid) {
      if (voucherReferenceItems.value.length === 0) return;
      voucherReferenceItems.value.forEach((item, index) => {
        let col = grid.getColumns()[0];
        if(index > grid.dataView.length - 1){
          grid.addRow(index, index, false, col);
        }
        let rowUpdate = grid.dataView[index];
        
        item.from_ref_detail_id = rowUpdate.ref_detail_id;
        
        grid.changeEditor(null, index, col).then(() => {
          if (rowUpdate.state === proxy.$ms.constant.ModelState.Empty) {
            rowUpdate.state = proxy.$ms.constant.ModelState.Insert;
          }
          rowUpdate.amount = item?.remaining_amount || 0;
          rowUpdate.amount_oc = item?.remaining_amount || 0;
          rowUpdate.inward_amount = item?.remaining_amount || 0;
          if ((rowUpdate?.quantity || 0) !== 0) {
            rowUpdate.unit_price = rowUpdate.amount / rowUpdate.quantity;
          }
          rowUpdate.description = item?.description;
          rowUpdate.budget_source_id = item?.budget_source_id;
          rowUpdate.budget_source_code = item?.budget_source_code;
          rowUpdate.budget_source_name = item?.budget_source_name;
          rowUpdate.budget_kind_item_code = item?.budget_kind_item_code;
          rowUpdate.budget_sub_kind_item_code = item?.budget_sub_kind_item_code;
          rowUpdate.budget_chapter_code = item?.budget_chapter_code;
          rowUpdate.budget_item_code = item?.budget_item_code;
          rowUpdate.budget_sub_item_code = item?.budget_sub_item_code;

          rowUpdate.task_code = item?.task_code;
          rowUpdate.task_id = item?.task_id;

          rowUpdate.statistic_code = item?.statistic_code;
          rowUpdate.statistic_id = item?.statistic_id;

          rowUpdate.project_code = item?.project_code;
          rowUpdate.project_id = item?.project_id;
        });
      });

      while(grid.dataView.length > voucherReferenceItems.value.length){
        proxy.model.Detail.pop();
      }
    }

    /**
     * Xóa chứng từ tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function removeVoucherReference() {
      voucherReferenceItems.value = [];
    }

    /**
     * Custom hàm thông báo lỗi khi validate tham chiếu chứn từ
     * @author NHCUONG 23.06.2023
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        isAcceptValidateVoucherReference.value = false;
        let errorData = error.response.data;
        if (errorData.Error === proxy.$ms.constant.ErrorCodes.ValidateAmountVoucherReference) {
          let {Data} = errorData.Data;
          let message = `Số tiền trên chứng từ <span style="font-weight: bold;">${proxy.model.ref_no}</span> vượt quá số tiền rút dự toán trên chứng từ <span style="font-weight: bold;">${Data.ref_type_name} - ${Data.ref_no}</span>. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?`;
          let title = 'Quỹ tiền âm';
          showConfirm(message, title, 410).then(async answer => {
            if (answer) {
              proxy.super('commandClick', baseDetailVoucher, proxy.$ms.constant.Command.SaveView);
              isAcceptValidateVoucherReference.value = true;
            }
          });
        } else {
          proxy.super('saveError', baseDetail, error, param, action);
        }
      }
    }

    /**
     * Hiển thị target link khi xem chứng từ
     * @author NHCUONG 26.06.2023
     */
    function showTargetLink(item) {
      proxy.super('showTargetLink', baseDetailVoucher, item);
    }

    /**
     * Lập chứng từ từ Hóa đơn xử lý đầu vào
     * NNLINH 20.10.2023
     */
    async function bindDataFromInbot(data, dataInbot, dataInbotDetail, dataInbotTax) {
      Object.assign(data, dataInbot);
      data.Detail = [];
      dataInbotDetail.forEach((detail, index) => {
        detail.sort_order = index;
        data.Detail.push(detail);
      });
      if (dataInbotTax?.length > 0) {
        data.BAWithdrawDetailTax = [];
        dataInbotTax.forEach((item, index) => {
          item.sort_order = index;
          data.BAWithdrawDetailTax.push(item);
        });
      }
      //Sinh hạch toán đồng thời
      await proxy.generateParallel(true, true);
    }

    /**
     *  Xử lý sau khi cất chứng từ
     * NNLINH 24.10.2023
     */
    function afterSubmitModeView(result, param) {
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: true,
          refNo: result.ref_no,
          // HMDUC2: Thêm biến phục vụ cập nhật refno_finance ngoài ds invoicebot_list
          isUpdatePosted: true,
          refNoBeforeUpdate: JSON.parse(proxy.refNoBeforeUpdate),
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);

    }

    /**
     * @override lại Hàm custom sau khi ghi sổ thành công => xử lý show form hạch toán chi phí lương/ bảo hiểm
     * DTQUOC 04.03.2024
     */
    async function customPostedSuccess(res, param) {
      const me = this;
      let details = {...proxy.model};
      details.IsGenerateData = true;
      proxy.setFormMode(proxy.$ms.constant.FormState.View);
      let dataTrans = await GLVoucherAPI.getDataByRelationRefId(details.ref_id);
      // đánh dấu là rule chứng từ hạch toán lương/ bảo hiểm (1-là CT hạch toán lương, 0-CT hạch toán bảo hiểm, nếu là null thì mặc định là hạch toán lương)
      let isFundSalary = true;
      if(dataTrans.tick_gl_voucher == null || dataTrans.tick_gl_voucher == proxy.$ms.constant.TickGLVoucher.Salary) {
        isFundSalary = true;
      }else {
        isFundSalary = false;
      }
      if(dataTrans) {
        let mes = proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncFundSalaryContent');
        showConfirm(
          mes.format('Chi tiền gửi', dataTrans.ref_no),
          proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherTitle'),
        ).then(answer => {
          switch (answer) {
            case true:
              // check quyền Sửa (vqphong - 12/12/2022)
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
              details.IsSyncData = true;
              popupUtil.show('GLGeneralVoucherDetail', {
                mode: proxy.$ms.constant.FormState.Edit,
                formApproveName: 'ApproveVoucherGLVoucherTab',
                // id: proxy.model.ref_id,
                refType: proxy.model.ref_type,
                IsFundSalary: isFundSalary,
                data: details,
                options: {
                  submit: data => {
                    proxy.view({
                      id: proxy.model.ref_id,
                      mode: proxy.$ms.constant.FormState.View,
                    });
                  },
                },
              });
              break;
            case false:
              break;
          }
        });
      }else {
        if(details.Detail) {
        let valueCheck = details.Detail.some((item) => {
          return (item.debit_account.startsWith("334") || item.debit_account.startsWith("332"));
        });
        if(valueCheck) {
          let optionDefault = 1;
          for(var item of details.Detail) {
            if(item.debit_account.startsWith("334")) {
              optionDefault = 1;
              break;
            }else {
              optionDefault = 2;
            }
          }
          generateVoucher(details.Detail, optionDefault);
        
        }
      }
      }
      
      //NNLINH 01.02.2023 custom cho phần view linkForm thuế
      if (me.options && typeof me.options.submitViewLinkFormTax === 'function') {
        me.options.submitViewLinkFormTax(res, param);
      }
    }

    const optionList = ref([
      {
        text: 'Sinh chứng từ Hạch toán chi phí lương',
        value: 1,
      },
      {
        text: 'Sinh chứng từ Hạch toán chi phí bảo hiểm',
        value: 2,
      },
    ]);

    /**
     * Hàm sinh chứng từ tương ứng (Hạch toán chi phí lương/ bảo hiểm)
     * DTQUOC 04.03.2024
     */
    async function generateVoucher(details, optionDefault) {
      let checkOption;
      showChooseOptionConfirmVertical('Bạn có muốn sinh chứng từ:', optionList.value, 'Sinh chứng từ', 500, optionDefault).then(
        async answer => {
          switch (answer.option) {
            case 1:
              checkOption = true;
              break;
            case 2:
              checkOption = false;
              break;
            default:
              break;
          }
          switch (answer.answer) {
            case true:
              generateGLVoucher(checkOption);
              break;
            case false:
              break;
            default:
              break;
          } 
      })
    }

    /**
     * Xử lý sau khi xóa chứng từ
     * NNLINH 26.10.2023
     */
    function deleteSuccess(record, result) {
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: false,
          refNo: null,
          refNoDelete: record?.ref_no, // HMDUC2 02/01/2023: Lưu lại ref_no ct xóa thành công phục vụ cập nhật lại chứng từ hoạch toán invoicebot_list
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('deleteSuccess', baseDetailVoucher, record, result);
    }

    const changeTriggersTab12 = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_detail_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'amount_oc',
      'budget_source_name',
      'quantity',
      'amount',
      'credit_account',
      'debit_account',
      'project_expense_code',
      'accounting_object_code',
    ]);
    const changeTriggersTab3 = shallowRef([
      'project_code',
      'accounting_object_code',
      'tax_rate',
      'tax_amount',
      'turn_over',
    ]);
    const changeTriggers = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_source_name',
      'amount_oc',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
    ]);
    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_type, ref_no }) => ({ ref_id, ref_type, ref_no }))];
    }

    /**
     * Lấy tên model lưu dữ liệu grid thuế
     */
    function getTaxKeyModel() {
      return "BAWithdrawDetailTax"
    }

    return {
      titleCode,
      changeTriggersTab12,
      changeTriggersTab3,
      changeTriggers,
      getParallelModel,
      module,
      backRouter: '/deposits/bawithdraw', //tên router form danh sách khi đóng sẽ quay lại
      toggleAbove,
      MsInput,
      comboboxDataRemote,
      budgetChapterColumns,
      onBudgetChapterComboboxLoadData,
      budgetChapterAPI,
      toggleAboveHandler,
      selectedTabHandler,
      selectedTab,
      currentLayout,
      propsData,
      projectComboConfig,
      accountComboMostDetailConfig,
      budgetSourceComboConfig,
      budgetSubKindItemComboConfig,
      budgetItemComboConfig,
      submitQuickAdd,
      columnParallel,
      columnsDataParalell,
      propsDataParalell,
      activityComboConfig,
      statisticComboConfig,
      accountingObjectComboConfig,
      budgetFeesComboConfig,
      TaskComboConfig,
      accountingObjectAPI,
      changeDataBusiness,
      budgetItemAPI,
      selectedMethodDistributeType,
      buttonPrints,
      accountColumns,
      bankInfoAPI,
      selectedBank,
      selectedAccountingObject,
      bankInfoColumns,
      bankColumns,
      onBankInfoComboboxLoadData,
      accountingObjectCustomColumns,
      onAccountingObjectComboboxLoadData,
      currencyColumns,
      onCurrencyComboboxLoadData,
      selectCurrency,
      customSelectCurrency,
      totalAmountComputed,
      assignValueCurrency,
      onActionBlur,
      statisticColumns,
      bindData,
      buttonUtilities,
      clickItemHandle,
      getSaveData,
      accountingObjectBankSelected,
      layoutTagDetail,
      layoutTagDetailOther,
      customColumns,
      getConfigLayout,
      saveSuccess,
      beforeBinding,
      changeDataBusinessCommon,
      defaultData,
      getDataDefault,
      toggleAboveHandlerGrid,
      onGridStyleColumn,
      onClickCKC,
      refType,
      clickQuickAccounting,
      accountingActions,
      saveAsNewAutoBusiness,
      onBlurActionDatePicker,
      viewAccount,
      customDefaultData,
      customVoucherLoadData,
      getMapDetailName,
      currencyCode,
      useTA,
      afterDeleteRelation,
      beforeBindData,
      getCustomReportParams,
      copyDownRow,
      copyDownRowExtend,
      copyActionClick,
      quickAddMultiItems,
      steps,
      onEditEvent,
      subSystemCode,
      quickSearchParam,
      bindDefaultData,
      showRefNoInvoice,
      isViewInvoce,
      selectedAccountingObjectBAWithDraw,
      onPosted,
      customUnPostedSuccess,

      isShowVoucherReference,
      voucherReferenceItems,
      showFormVoucherReference,
      getRefTypeView,
      callbackChooseItem,
      setVoucherReferenceInfo,
      getGridDetail,
      initNewData,
      removeVoucherReference,
      saveError,
      showTargetLink,

      configAccountingGrid,
      configTaxGrid,
      configParallelGrid,
      disabledDelete,
      stepsDynamic,
      bankInfoCombo,
      accountingObjectCombo,
      bindDataFromInbot,
      afterSubmitModeView,
      deleteSuccess,
      viewAccount,
      refNoBeforeUpdate,
      DBStartDateString: proxy.DBStartDateString,
      isShowRiskPopup,
      isShowQuestionIcon,
      riskWarningMessage,
      validateRiskCustomerVendor,
      customPostedSuccess,
      getParamDeleteDetail,
      getTaxKeyModel,
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    accountingObjectCombo() {
      return this.accountingObjectCombo
        .sort(function (a, b) {
          return a.accounting_object_code - b.accounting_object_code;
        })
        .sort(function (a, b) {
          return a.is_employee - b.is_employee;
        });
    },
  },
};
</script>

<style lang="scss">
.ba-with-draw-detail {
  @import './BAWithDrawDetail.scss';
  .btn {
    &.icon-button {
      background: none !important;
    }
  }
}
</style>
